var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25781 12.1055C2.25781 17.6283 6.73496 22.1055 12.2578 22.1055C17.7807 22.1055 22.2578 17.6283 22.2578 12.1055C22.2578 6.58262 17.7807 2.10547 12.2578 2.10547C6.73496 2.10547 2.25781 6.58262 2.25781 12.1055ZM13.2578 11.1055V12.1055V18.1055V19.1055H11.2578V18.1055V12.1055V11.1055H13.2578ZM11.2578 7.10547V8.10547H13.2578V7.10547V6.10547V5.10547H11.2578V6.10547V7.10547Z",
    fill: "#E11010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.eb7a7499e10fb0890a29cbd1956ecba3.svg";
export { ForwardRef as ReactComponent };